import { useAppDispatch, useAppSelector } from '@/store';
import { setPnld } from '@/store/slices/pnldSlice';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

export function useSelectedPnld() {
  const dispatch = useAppDispatch();
  const pnldId = useAppSelector((state) => state.pnld.selected);

  useEffect(() => {
    if (!pnldId) {
      const cookiePnld = Cookies.get('selectedPnld');
      if (cookiePnld) {
        dispatch(setPnld(cookiePnld));
      }
    }
  }, [pnldId, dispatch]);

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (!pnldId) return;
    setLoading(true);
    fetch('/api/graphql/getPnldByPk', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ variables: { id: pnldId } }),
    })
      .then((res) => res.json())
      .then((result) => {
        setData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [pnldId]);

  const status = data?.pnld_by_pk?.locked ?? null;

  const setPnldId = (id: string) => {
    dispatch(setPnld(id));
    Cookies.set('selectedPnld', id);
  };

  return {
    pnldId,
    statusPnld: status,
    loading,
    error,
    setPnldId,
  };
}
